import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 13,
	fill: "none",
	viewBox: "0 0 8 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M3.4 2.6a1.2 1.2 0 1 1 1.5 2l-.8.6A2.6 2.6 0 0 0 3 7.3V8h2v-.7c0-.5.8-.8 1.1-1.1a3.2 3.2 0 1 0-4-5.1L.8 2l1.3 1.6 1.3-1Zm1.9 8.2a1.3 1.3 0 1 1-2.5 0 1.3 1.3 0 0 1 2.5 0Z",
		clipRule: "evenodd"
	})
});
export default SvgQuestionIcon;
